import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js";
import ServiceNav from "../components/ServiceNav";
import ServiceHero from "../components/ServiceHero";
import { FiCheckCircle, FiTrendingUp, FiShield, FiBarChart2 } from "react-icons/fi";
import { ServiceCta } from "../components/CtaSystem";
import "./Bigdatasolution.css";

const Bigdatasolution = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="big-data-container">
      {/* Hero Section */}
      <ServiceHero
        kicker="SERVICE 01"
        title="Big Data Solution"
        description="Unlock the power of data with advanced analytics, AI-driven insights, and scalable data solutions."
        bgImage="/service01.png"
        onConnectClick={() => setIsPopupOpen(true)}
      />

      {/* About Big Data */}
      <section className="about-big-section">
        <div className="about-content">
          <div className="about-text">
            <h2>What is Big Data?</h2>
            <p>
              Big Data refers to extremely large and complex datasets that require 
              specialized tools and techniques for processing, analysis, and visualization.
            </p>
            <ul>
              <li><FiCheckCircle className="check-icon" /> Data Collection from Various Sources</li>
              <li><FiCheckCircle className="check-icon" /> Real-time Processing & Analysis</li>
              <li><FiCheckCircle className="check-icon" /> AI-powered Insights & Predictions</li>
            </ul>
          </div>
          <div className="vector-image">
            <img src="./big-img.png" alt="Big Data Vector" />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Big Data Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon"><FiTrendingUp /></span>
            <h3>Scalability</h3>
            <p>Handle massive datasets with cloud-based solutions.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiShield /></span>
            <h3>Security</h3>
            <p>Ensure data protection with industry-grade encryption.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FiBarChart2 /></span>
            <h3>AI-Powered Insights</h3>
            <p>Leverage AI & ML for predictive analytics and automation.</p>
          </div>
        </div>
      </section>

      {/* Service CTA */}
      <ServiceCta
        eyebrow="BIG DATA SOLUTION"
        heading="Unlock Enterprise-Grade Big Data Analytics Today"
        primaryBtnText="Connect Now!"
        onPrimaryClick={() => setIsPopupOpen(true)}
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />

      {/* Service Navigation */}
      <ServiceNav currentPath="/big-data-solution" />

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default Bigdatasolution;
